import type { InterviewResult, InterviewType } from '@/types/candidates';

export const INTERVIEW_TYPE_LABEL: Record<InterviewType, string> = {
  HR_CALL: 'HR call',
  TECH: 'Tech',
  FINAL: 'Final',
  OTHER: 'Other',
};

export const INTERVIEW_RESULT_LABEL: Record<InterviewResult, string> = {
  SCHEDULED: 'Scheduled',
  COMPLETED: 'Completed',
  CANCELED: 'Canceled',
  NO_SHOW: 'No-show',
};
